<template>
    <div class="tabs_content baseInfo">
        <!-- <div class="title1">专利案件信息</div> -->
        <div v-if="fsList&&fsList.length>0">
            <p class="margbsm">复审无效数据</p>
            <v-data-table
                item-key="id"
                :headers="lawHeader"
                :items="fsList"
                :loading="loading1"
                show-expand
                class="elevation-1"
            >
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <div class="border-bottom padsm">
                        <h5>法律依据</h5>
                        <p>{{item.legalBasis}}</p>
                    </div>
                <div v-html="item.content"></div>
                </td>
            </template>
            </v-data-table>
        </div>
        <div v-else-if="lawList&&lawList.length>0">
            <p class="margbsm">案件数据</p>
            <v-data-table
                item-key="id"
                :headers="lawHeader"
                :items="lawList"
                :loading="loading1"
                show-expand
                class="elevation-1"
                :items-per-page='20'
                :footer-props="{
                    itemsPerPageAllText: '全部',
                    itemsPerPageText: '每页',
                    showCurrentPage: true,
                    itemsPerPageOptions: [5,10,15,20,-1],
                }"
            >
                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                        <div class="border-bottom padsm">
                            <h5>法律依据</h5>
                            <p>{{item.legalBasis}}</p>
                        </div>
                    <div v-html="item.content"></div>
                    </td>
                </template>
            </v-data-table>
        </div>
        <div v-else>
            <span>暂无数据</span>
        </div>
    </div>
</template>
<script>
import {mapActions} from'vuex'
export default {
      props:{
        pid:{
            id:''
        }
    },
    name:"caseInfo",
    data(){
        return{
            loading2:false,
            transList:[],
            id:'',
            headers: [
                {
                    text: '公开（公告）号',
                    align: 'start',
                    sortable: false,
                    value: 'applicationNumber'
                },
                {
                    text: '标题',
                    align: 'start',
                    sortable: false,
                    value: 'title'
                },
                {
                    text: '发明人',
                    align: 'start',
                    sortable: false,
                    value: 'inventor'
                },
                {
                    text: '申请日',
                    align: 'start',
                    sortable: false,
                    value: 'applicationDate'
                },
                {
                    text: '法律状态/事件',
                    align: 'start',
                    sortable: false,
                    value: 'legalStatus'
                },
                {
                    text: '当前申请（专利权）人',
                    align: 'start',
                    sortable: false,
                    value: 'applicant'
                }
            ],
            transHeader: [
                {
                    text: '执行时间',
                    align: 'start',
                    sortable: false,
                    width:"150",
                    value: 'executeDate'
                },
                {
                    text: '类型',
                    align: 'start',
                    sortable: false,
                    width:"180",
                    value: 'type'
                },
                {
                    text: '内容',
                    align: 'start',
                    sortable: false,
                    value: 'content'
                },
            ],
            lawHeader: [
                {
                    text: '决定号',
                    align: 'start',
                    sortable: false,
                    value: 'decisionNumber'
                },
                {
                    text: '决定日',
                    align: 'start',
                    sortable: false,
                    value: 'decisionDate'
                },
                {
                    text: '委内编号',
                    align: 'start',
                    sortable: false,
                    value: 'number'
                },
                {
                    text: '审定公告日',
                    align: 'start',
                    sortable: false,
                    value: 'applicationDate'
                },
                {
                    text: '复审请求人',
                    align: 'start',
                    sortable: false,
                    value: 'fsPerson'
                },
                {
                    text: '合议组组长',
                    align: 'start',
                    sortable: false,
                    value: 'teamLeader'
                },
                {
                    text: '主审员',
                    align: 'start',
                    sortable: false,
                    value: 'primaryExaminer'
                },
                {
                    text: '参审员',
                    align: 'start',
                    sortable: false,
                    value: 'attendExaminer'
                },
                {
                    text: '操作',
                    align: 'start',
                    sortable: false,
                    value: 'data-table-expand'
                }
            ],
        }
    },
    watch:{
         pid:{
          handler(n,o){
              console.log(n,o)
              this.getLaw(n.id)
          },
          deep:true
          
     }
    },
         created(){
         console.log(200000,this.pid)
        this.getLaw(this.pid.id)
    },
    methods:{
        ...mapActions('search',['getPatentLaw']),
        getLaw(val) {
            this.loading1 = true
            let data = {
                params: {
                   udn: val
                }
            }
            let _this = this
            this.getPatentLaw({data: data,handle(res) {
                _this.loading1 = false
                _this.lawList = res.lawList
                _this.fsList = res.fsList
            }})
        },
    }

}
</script>